import { Root } from "react-dom/client";
import { AddBizReactLoader } from "../../../Js/React/loader";
import OneEvent from "./OneEvent";
import EventList from "./EventList";

let root: Root | undefined;
AddBizReactLoader(root, 'bizoneevent', (e) => {
	const params = (e.detail as { params: { eventId: number } }).params;
	return <OneEvent eventId={params.eventId} />;
});

AddBizReactLoader(root, 'bizeventlist', (e) => {
	const params = (e.detail as { params: { eventFilter: string } }).params;
	return <EventList eventFilter={params?.eventFilter} />;
});